<script lang="ts">
    import {ArrowsRepeatCountOutline, ExclamationCircleSolid, UploadSolid} from "flowbite-svelte-icons";
    import {Button, Fileupload, Input, Modal, Radio, Select, Textarea, Toggle} from "flowbite-svelte";
    import {storeEmployeeImage} from "$lib/calls/files";
    import type {Employee} from "$lib/types/employee";
    import {createEventDispatcher} from "svelte";
    import {documentTags, documentWantsNumber, tagToString} from "$lib/utils/documentTag";
    import {globalToast} from "$lib/stores/toast";
    import dayjs from "dayjs";
    import ModalHeader from "$lib/components/ui/ModalHeader.svelte";
    import ModalFooter from "$lib/components/ui/ModalFooter.svelte";
    import FileDrop  from "$lib/components/FileDrop.svelte";

    export let open = false;
    export let employee: Employee;

    export let accept = 'image/*';

    const dispatch = createEventDispatcher();
    let loading = false;

    let photo: Blob;
    let photoTag = 'other'
    let documentNumber = ''
    let photoTags = documentTags.filter(x => !['contract-document', 'avatar'].includes(x.value))
    let overwriteName = true;
    let documentName = '';
    let frontOrBack = 'front'
    const photoLoader = (accepted, rejected) => {
        console.log({accepted, rejected})
        if(rejected.length > 0) {
            $globalToast.timed('Datei nicht zugelassen', 3000, ExclamationCircleSolid)
        } else {
            photo = accepted[0]
        }

        // photo = e.target.files[0]
    }

    let submitPhoto = async () => {
        loading = true

        const res = await storeEmployeeImage(photo, photoTag, employee.uuid, documentNumber, overwriteName ? documentName : null)
        employee.images = [...res.images]
        loading = false
        open = false
        dispatch('uploaded', res.images.sort((a,b) => a.id - b.id).pop())
    }
    const generateName = () => {
        const side = (photoTag === 'id-card' || photoTag === 'license') ? (frontOrBack === 'front' ? '_Vorderseite' : '_Rückseite') : ''
        documentName = documentTags.find(x => x.value === photoTag).name + side + '_' + employee.firstName + '_' + employee.lastName + '_' + dayjs().format('DD.MM.YYYY')
    }
</script>


<Modal bind:open on:close={photo=null}>
    <svelte:fragment slot="header"><ModalHeader title="Bild hochladen"/></svelte:fragment>
    <h3 class="mt-3 text-xl text-neutral-600">Upload Image</h3>

    <form on:submit|preventDefault={submitPhoto}
          class="flex flex-col gap-3">
        <Select type="text" class="w-full"
               name="imageTag"
               bind:value={photoTag}
                on:change={() => generateName()}
               items={photoTags}
               placeholder="Image Tag">
        </Select>
        {#if documentWantsNumber(photoTag)}
        <Input type="text" class="w-full"
               name="number"
               bind:value={documentNumber}
               placeholder="{tagToString(photoTag)}-Nummer">
            <ArrowsRepeatCountOutline slot="left" class="w-4 h-4"/>
        </Input>
        {/if}
        <Toggle on:change={() => generateName()} bind:checked={overwriteName}>Dateiname überschreiben</Toggle>

        {#if overwriteName}
            {#if photoTag === 'id-card' || photoTag === 'license' }
                <div class="flex gap-3">
                    <Radio on:change={() => generateName()} value="front" bind:group={frontOrBack}>Vorderseite</Radio>
                    <Radio on:change={() => generateName()} value="back" bind:group={frontOrBack}>Rückseite</Radio>
                </div>
            {/if}

            <Input type="text" bind:value={documentName} placeholder="Dokumentenname"/>

        {/if}
        <FileDrop extract={photoLoader} allowedFiles={['jpg', 'jpeg', 'png', 'pdf', 'gif']} allowedSize="6MB"/>

        {#if photo}
            <div class="flex gap-3 w-full justify-between">
                <span>{photo.name}</span>

            </div>
        {/if}
    </form>
    <svelte:fragment slot="footer">
        <ModalFooter on:abort={() => {open = false}} >
            <svelte:fragment slot="right">
                <Button on:click={() => submitPhoto()}><UploadSolid class="w-4 h-4 me-2"/> Upload</Button>
            </svelte:fragment>
        </ModalFooter>
    </svelte:fragment>
</Modal>